{
  "pt": {
    "activity": {
      "attributes": {
        "end": "Fim",
        "now": "Agora",
        "title": "Feed de actividades"
      },
      "labels": {
        "no_activities": "Nenhuma atividade ainda",
        "no_activities_subtitle": "Quando alguém criar um novo anúncio, decisão, pergunta, etc., você verá isso aqui.",
        "not_opened_yet": "Ainda não visto"
      },
      "projects": {
        "announcement": {
          "create": "criou um post de notícias."
        },
        "building": {
          "create": "criado edifício <i>'{notifiable_name}'</i>."
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "criou o gráfico <i>'{notifiable_name}'</i>."
        },
        "phase": {
          "create": "fase criada <i>'{notifiable_name}'</i>."
        },
        "published": {
          "customer": "publicou a decisão <i>'{notifiable_name}'</i> para o cliente.",
          "partners": "publicou a decisão <i>'{notifiable_name}'</i> para o(s) parceiro(s)."
        },
        "question": {
          "create": "criada a pergunta <i>'{notifiable_name}'</i> nas FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "espaço criado <i>'{notifiable_name}'</i>.",
          "update": "espaço atribuído <i>'{notifiable_name}'</i> a uma unidade."
        },
        "survey_type": {
          "create": "inquérito criado do tipo <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "atribuído <i>'{notifiable_name}'</i> a um cliente.",
          "create": "unidade criada <i>'{notifiable_name}'</i>.",
          "invisibled": "revogou o acesso do cliente para <i>'{notifiable_name}'</i>.",
          "unassign": "não atribuído <i>'{notifiable_name}'</i> do cliente.",
          "visibled": "deu acesso ao cliente para <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "criou um post de notícias."
        },
        "decision": {
          "create": "decisão criada <i>'{notifiable_name}'</i>.",
          "not_interested": "não está interessado na decisão <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "publicou a decisão <i>'{notifiable_name}'</i> para o cliente.",
            "partners": "publicou a decisão <i>'{notifiable_name}'</i> para o(s) parceiro(s)."
          },
          "relaunched": "tornou a decisão <i>'{notifiable_name}'</i> novamente disponível."
        },
        "decision_document": {
          "create": "documento carregado <i>'{notifiable_name}'</i> na decisão <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprovou a proposta <i>\"{notifiable_name}\"</i> na decisão <i>\"{group_name}\"</i>.",
          "create": {
            "customer": "proposta partilhada <i>'{notifiable_name}'</i> com o cliente.",
            "employee": "proposta criada <i>'{notifiable_name}'</i>.",
            "partnergroup": "proposta partilhada <i>'{notifiable_name}'</i> com o parceiro <i>{target_name}</i>."
          },
          "unapproved": "proposta não aprovada <i>\"{notifiable_name}'</i> na decisão <i>\"{group_name}'</i>.",
          "updated": "proposta actualizada <i>\"{notifiable_name}\"</i> na decisão <i>\"{group_name}\"</i>."
        },
        "document": {
          "create": "documento carregado <i>'{notifiable_name}'</i>."
        },
        "issue": {
          "approval": {
            "create": "criado pedido de aprovação para <i>'{notifiable_name}'</i>.",
            "delete": "pedido de autorização suprimido para <i>'{notifiable_name}'</i>.",
            "rejected": "rejeitou este ponto."
          },
          "approved": "questão aprovada <i>'{notifiable_name}'</i>.",
          "create": "criado problema <i>'{notifiable_name}'</i>.",
          "status": {
            "update": "alterou o estado do problema <i>'{notifiable_name}'</i> para <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "proposta removida <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "criada a pergunta <i>'{notifiable_name}'</i> nas FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "espaço atribuído <i>'{notifiable_name}'</i> a esta unidade."
        },
        "survey": {
          "create": "inquérito criado <i>'{notifiable_name}'</i>.",
          "published": "inquérito publicado <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "iniciou a conversa <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "moveu uma mensagem para a conversação <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "atribuído <i>'{notifiable_name}'</i> a um cliente.",
          "invisibled": "revogou o acesso do cliente para <i>'{notifiable_name}'</i>.",
          "unassign": "não atribuído <i>'{notifiable_name}'</i> do cliente.",
          "visibled": "deu acesso ao cliente para <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}